import { render } from "./FriendCard-InviteReceived.vue?vue&type=template&id=6ee159b1&scoped=true"
import script from "./FriendCard-InviteReceived.vue?vue&type=script&lang=js"
export * from "./FriendCard-InviteReceived.vue?vue&type=script&lang=js"

import "./FriendCard-InviteReceived.vue?vue&type=style&index=0&id=6ee159b1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ee159b1"]])

export default __exports__